import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=32a2507f"
import script from "./parent.vue?vue&type=script&lang=js"
export * from "./parent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a2507f')) {
      api.createRecord('32a2507f', component.options)
    } else {
      api.reload('32a2507f', component.options)
    }
    module.hot.accept("./parent.vue?vue&type=template&id=32a2507f", function () {
      api.rerender('32a2507f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/routerView/parent.vue"
export default component.exports